export default "__VITE_ASSET__GMvUlzUP__"